import { CSSProperties } from 'react'

export const siderStyle: CSSProperties = { zIndex: 9999999 }
export const drawerMenuBodyStyle: CSSProperties = { padding: 0 }
